import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const financialStrengthAC: CriterionType[] = [
  {
    id: 'FIN-20',
    label: 'Quick ratio',
    shortLabel: 'QuickRt',
    group: AC_GROUPS.financialStrength,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'FIN-30',
    label: 'Payout ratio (%)',
    shortLabel: 'PayoutRt',
    unit: '%',
    group: AC_GROUPS.financialStrength,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'FIN-40',
    label: 'Shareholder equity ratio (%)',
    shortLabel: 'EquityRt',
    unit: '%',
    group: AC_GROUPS.financialStrength,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'FIN-130',
    label: 'Reinvestment rate (%)',
    shortLabel: 'ReinvestRt',
    unit: '%',
    group: AC_GROUPS.financialStrength,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'FIN-50',
    label: 'Interest coverage',
    shortLabel: 'IntCov',
    group: AC_GROUPS.financialStrength,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'FIN-120',
    label: 'Working capital per share/price',
    shortLabel: 'WCPS/Price',
    group: AC_GROUPS.financialStrength,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'FIN-60',
    label: 'Total debt to assets (%)',
    shortLabel: 'Debt/Assets',
    unit: '%',
    group: AC_GROUPS.financialStrength,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'FIN-70',
    label: 'Total debt to capital (%)',
    shortLabel: 'Debt/Cap',
    unit: '%',
    group: AC_GROUPS.financialStrength,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'FIN-80',
    label: 'Total debt to equity (%)',
    shortLabel: 'Debt/Equity',
    unit: '%',
    group: AC_GROUPS.financialStrength,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'FIN-90',
    label: 'Long-term debt to assets (%)',
    shortLabel: 'LTDebt/Assets',
    unit: '%',
    group: AC_GROUPS.financialStrength,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'FIN-100',
    label: 'Long-term debt to equity (%)',
    shortLabel: 'LTDebt/Equity',
    unit: '%',
    group: AC_GROUPS.financialStrength,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'FIN-110',
    label: 'Long-term debt to capital (%)',
    shortLabel: 'LTDebt/Cap',
    unit: '%',
    group: AC_GROUPS.financialStrength,
    type: AC_TYPES.normal,
    withRange: true,
  },
];

export default financialStrengthAC;
